import { useQuery } from 'react-query';
import Api from '../../../../shared/Api';

export function getPhotographersForBookingUnbookedOrders<T>(
    selectedOrderId,
    bookingDate,
    isAdvancedMode,
    hideTravelTimes,
    executionTime,
    regionId = null
) {
    const orderParameters = {
        regionId,
        isAdvanceMode: isAdvancedMode,
        includeTraveltimes: !hideTravelTimes,
        year: bookingDate.getFullYear(),
        month: bookingDate.getMonth() + 1,
        day: bookingDate.getDate(),
        hours: null,
        minutes: null,
        executionTime: executionTime
    };

    return useQuery(
        [
            'availablePhotographers',
            regionId,
            selectedOrderId,
            bookingDate,
            isAdvancedMode,
            hideTravelTimes,
            executionTime
        ],
        () =>
            new Api().get(
                `/views/photographer-booking/se360/unbooked/${selectedOrderId}`,
                orderParameters
            )
    );
}
